import { hasActiveSession, getProactiveTriggered } from 'app/modules';
import configSelectors from 'selectors/configuration';
import updateWelcomeMessage from 'actions/session/updateWelcomeMessage';
import hideDefaultAndCustomWidget from 'actions/ui/hideDefaultAndCustomWidget';
import uiEvents from 'events/ui';
import executeRule from 'actions/configuration/executeRule';
import { DISPLAY_TYPE } from 'enums/configuration';

export default function evaluateRules(dispatch, getState) {
  const state = getState();
  const rule = configSelectors.getRule(state.configuration);
  const display = configSelectors.getDisplay(state.configuration);

  if (
    display === DISPLAY_TYPE.ALL_PAGES ||
    hasActiveSession(state) ||
    configSelectors.getKillswitchIsOn(state.configuration)
  ) {
    // no rules applies
    return;
  }

  dispatch(uiEvents.suppress());
  if (!rule) {
    if (state.ui.isMinimized) {
      dispatch(hideDefaultAndCustomWidget);
    }
    return;
  }

  dispatch(updateWelcomeMessage(rule.message));

  const proactiveHasTriggered = getProactiveTriggered(state);
  const delay = proactiveHasTriggered && rule.proactive ? 0 : rule.delay;

  delay
    ? setTimeout(() => {
        dispatch(executeRule);
      }, delay)
    : dispatch(executeRule);
}
